module.exports = {"441821100":"石角镇","441821101":"水头镇","441821102":"汤塘镇","441821103":"龙山镇","441821104":"高岗镇","441821107":"迳头镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441821.json
// module id = 2048
// module chunks = 0